import { render, staticRenderFns } from "./t3-alert.vue?vue&type=template&id=b5d8a866&"
import script from "./t3-alert.vue?vue&type=script&lang=js&"
export * from "./t3-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports